














import store from '@/store'
import TextBox from '@/views/atoms/TextBox.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'

export default
  name: 'LabelInput'

  components: {
    TextBox
    ErrorLabel
  }

  props:
    value:
      type: String
      default: ''
    # ラベル
    label:
      type: String
      default: null
    # Props名
    name:
      type: String
      default: ''
    # maxlength
    maxlength:
      type: Number
      default: 200
    # タイプ
    type:
      type: String
      default: 'text'
    # APIからの返却値(エラー表示)
    apiData:
      type: Object

  computed: {
      getApiData: () ->
        return @apiData
  }

  methods: {
  }
